import {PrismicNextImage} from '@prismicio/next'
import {useInView, motion} from 'framer-motion'
import {ProductDeepDiveV2SliceDefaultPrimaryProductsItem} from 'prismicio-types'
import {useRef} from 'react'
import cn from 'classnames'

const itemVariants = {
  hidden: {opacity: 0},
  visible: (custom: number) => ({
    opacity: 1,
    transition: {delay: custom * 0.1, duration: 0.6, ease: 'easeIn'},
  }),
}

type ProductCardProps = {
  product: ProductDeepDiveV2SliceDefaultPrimaryProductsItem
  index: number
}

export const ProductCard = ({product, index}: ProductCardProps) => {
  const ref = useRef(null)
  const isInView = useInView(ref, {amount: 0.1, once: false})

  return (
    <motion.div
      key={index}
      ref={ref}
      custom={index}
      variants={itemVariants}
      initial="hidden"
      animate={isInView ? 'visible' : 'hidden'}
      className={cn(
        'flex flex-col justify-between rounded-lg border border-moss-white/[10%] bg-[#002916] p-4 max-lg:gap-6 lg:p-6',
        {
          'lg:h-[486px] col-span-full md:col-span-6 gap-12 pb-0': index < 2,
          'lg:h-[436px] col-span-full md:col-span-4': index >= 2,
        },
      )}
    >
      <div className="flex flex-col gap-2 lg:max-w-[289px] lg:gap-3">
        <p className="text-tg-body-l text-moss-white">{product.title}</p>
        <div className={cn('flex flex-col justify-between gap-6', {'max-w-[294px]': index < 2})}>
          <p className="text-tg-body-m   text-moss-white/[70%]">{product.description}</p>
        </div>
      </div>
      <PrismicNextImage field={product.asset} className="object-contain max-lg:min-h-[214px]" />
    </motion.div>
  )
}
